import { render, staticRenderFns } from "./CrmTicketEdit.vue?vue&type=template&id=5cfbc934&scoped=true"
import script from "./CrmTicketEdit.vue?vue&type=script&lang=js"
export * from "./CrmTicketEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfbc934",
  null
  
)

export default component.exports